module.exports = __webpack_public_path__ + "static/media/phone.04ba04cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/phone.svg
// module id = 70
// module chunks = 0